/**
 * Infinite Options - Auto Add Logo Digitizing Service
 * When a customer uploads a logo via Uploadery inside Infinite Options
 * and adds the product to cart, this script adds the Logo Digitizing Service.
 *
 * Detection: Checks for a .uploaderyResponse img element inside
 * #infiniteoptions-container. Uploadery creates this element only after
 * a successful file upload.
 *
 * Cart hook: Listens for add-to-cart button clicks. Infinite Options
 * (customizery.js) uses XHR instead of the theme's fetch-based pub/sub system,
 * so we use a non-invasive click listener to avoid interfering with the cart drawer.
 *
 * Product: Logo Digitizing Service
 * Variant ID: 49817116967217
 * Price: $50.00
 */

(function() {
  'use strict';

  var DIGITIZING_FEE_VARIANT_ID = 49817116967217;
  var DEBUG = true;
  var nativeFetch = window.fetch.bind(window);
  var processingFee = false;

  function log() {
    if (DEBUG) {
      var args = ['[IO Digitizing Fee]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function getFetch() {
    return nativeFetch;
  }

  log('Initializing...');

  // ============================================================================
  // UPLOAD DETECTION
  // ============================================================================

  /**
   * Check if a logo has been uploaded by looking for the Uploadery preview.
   * When a file is uploaded, Uploadery creates:
   *   <div class="uploaderyResponse"><p>Preview:</p><img src="https://..."></div>
   * When no file is uploaded, this element does not exist.
   */
  function hasLogoUpload() {
    var container = document.querySelector('#infiniteoptions-container');
    if (!container) return false;

    var preview = container.querySelector('.uploaderyResponse img');
    if (preview && preview.src) {
      log('Uploadery preview found:', preview.src);
      return true;
    }

    return false;
  }

  // ============================================================================
  // CART OPERATIONS
  // ============================================================================

  function checkCartForDigitizingFee() {
    return getFetch()('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var hasIt = cart.items.some(function(item) {
          return item.variant_id &&
                 item.variant_id.toString() === DIGITIZING_FEE_VARIANT_ID.toString();
        });
        log('Digitizing fee already in cart:', hasIt);
        return hasIt;
      })
      .catch(function() { return false; });
  }

  function addDigitizingFeeToCart() {
    log('Adding Logo Digitizing Service to cart...');

    return getFetch()('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: DIGITIZING_FEE_VARIANT_ID,
          quantity: 1
        }]
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (data.status && data.status >= 400) {
        log('Error adding digitizing fee:', data.description || data.message);
        return false;
      }
      log('Logo Digitizing Service added successfully');
      return true;
    })
    .catch(function(error) {
      log('Failed to add digitizing fee:', error);
      return false;
    });
  }

  function refreshCartUI() {
    // Fetch the cart-drawer section HTML and replace its contents
    getFetch()('/cart?section_id=cart-drawer')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(html, 'text/html');
          var newContent = newDoc.querySelector('.drawer__inner');
          var oldContent = cartDrawer.querySelector('.drawer__inner');
          if (newContent && oldContent) {
            oldContent.innerHTML = newContent.innerHTML;
            log('Cart drawer content refreshed');
          }
        }

        // Also update cart icon bubble count
        getFetch()('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            // Update cart count bubbles
            var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
            bubbles.forEach(function(bubble) {
              bubble.textContent = cart.item_count;
            });

            // Publish event for any other listeners
            if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'infinite-options-digitizing-fee',
                cartData: cart
              });
            }
            log('Cart UI fully refreshed');
          });
      })
      .catch(function(error) {
        log('Cart refresh error:', error);
      });
  }

  // ============================================================================
  // ADD-TO-CART HOOK
  // ============================================================================

  function onProductAdded() {
    if (processingFee) {
      log('Already processing fee, skipping');
      return;
    }

    if (!hasLogoUpload()) {
      log('No logo upload detected - skipping digitizing fee');
      return;
    }

    log('Product added with logo upload - checking for digitizing fee...');
    processingFee = true;

    checkCartForDigitizingFee().then(function(alreadyInCart) {
      if (alreadyInCart) {
        log('Digitizing fee already in cart');
        processingFee = false;
        return;
      }
      addDigitizingFeeToCart().then(function(success) {
        if (success) refreshCartUI();
        processingFee = false;
      });
    });
  }

  // ============================================================================
  // ADD-TO-CART DETECTION - Non-invasive click listener
  // ============================================================================

  var pendingCheck = null;

  function monitorAddToCartButton() {
    document.addEventListener('click', function(e) {
      // Find if click was on or inside an add-to-cart submit button
      var button = e.target.closest('[type="submit"], .product-form__submit, button[name="add"]');
      if (!button) return;

      var form = button.closest('form[action="/cart/add"], product-form');
      if (!form) return;

      log('Add to cart button clicked');

      // Clear any pending check
      if (pendingCheck) clearTimeout(pendingCheck);

      // Wait for IO's postVariants to finish adding all items
      pendingCheck = setTimeout(function() {
        pendingCheck = null;
        onProductAdded();
      }, 3000);
    }, true);

    log('Add-to-cart button monitoring active');
  }

  // ============================================================================
  // INITIALIZATION
  // ============================================================================

  function init() {
    monitorAddToCartButton();
    log('Initialization complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.debugDigitizingUpload = {
    hasLogoUpload: hasLogoUpload,
    addFeeNow: addDigitizingFeeToCart,
    checkCart: checkCartForDigitizingFee
  };

})();